import { inject, Pipe, PipeTransform } from '@angular/core';
import { AppUtilityService } from '../utility/app.utility';
import { GlobalsStore } from '../stores/globals.state';

@Pipe({
  name: 'safeNumber',
  standalone: true,
})
export class SafeNumberPipe implements PipeTransform {
  readonly globalsStore = inject(GlobalsStore);
  constructor(private utility: AppUtilityService) {}

  transform(
    value: number | string | null | undefined,
    indicatorId?: string,
    skipUnit = true,
    unit?: string
  ): string | null {
    if (value === null || value === '' || value === undefined) {
      return 'k. A.';
    } else if (isNaN(Number(value))) {
      return String(value);
    } else if (indicatorId) {
      return this.globalsStore.getFormattedValue(
        Number(value),
        indicatorId,
        skipUnit
      );
    } else {
      return this.utility.formatNumberToGerman(
        Number(value),
        unit === '%' ? 1 : 0
      );
    }
  }
}
